export enum TipoEvento {
    Publico = 1,
    Privado = 2,
  }